export default function authHeader() {
  try {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      console.warn("No user found in localStorage");
      return {};
    }
    let user = JSON.parse(userStr);
    // console.log({ user });
    if (user && user.accessToken) {
      return { Authorization: "Bearer " + user.accessToken };
    } else {
      console.warn("User found but no accessToken");
      return {};
    }
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/authHeader.js